<template>
  <div>
    <Header v-if="showHeader" />
    <router-view />
  </div>
</template>
<script>
import Header from "./header";
export default {
  name: "index",
  components: {
    Header,
  },
  watch: {
    $route(to, from) {
      let index = ["Order", "Zfb"].indexOf(to.name);
      this.showHeader = index < 0 ? true : false;
    },
  },
  data() {
    let index = ["Order", "Zfb"].indexOf(this.$route.name);
    let showHeader = index < 0 ? true : false;
    return {
      showHeader: showHeader,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/page/index.vue